import { configureStore } from '@reduxjs/toolkit';

import adminReducers from './AppReducers/AdminReducers';

const store = configureStore({
  reducer: {
    admin: adminReducers,
  },
});

export default store;
